<script setup lang="ts">
import StarRating from '~/components/common/StarRating.vue'

defineProps<{ rating: number; count: number }>()

function scrollToReviews() {
  if (typeof document === 'undefined') return
  const el = document.getElementById('opinie')
  el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
function onKey(e: KeyboardEvent) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault()
    scrollToReviews()
  }
}
</script>

<template>
  <div
    class="pdp__rating"
    role="button"
    tabindex="0"
    :aria-label="`Ocena sklepu ${rating.toFixed(1)} na 5 — przejdź do opinii`"
    @click="scrollToReviews"
    @keydown="onKey"
  >
    <span class="pdp__rating-score" aria-hidden="true">{{ rating.toFixed(1) }}/5</span>
    <StarRating :rating="rating" size="md" aria-hidden="true" />
    <span class="pdp__review-count">{{ count }} opinii</span>
  </div>
</template>

<style scoped>
/*
 * Layout (display/align/gap) dla .pdp__rating jest już zdefiniowany globalnie
 * w [slug].vue (<style scoped> tego widoku) — Vue nakłada atrybut scope rodzica
 * na ROOT węzeł tego komponentu, więc ta reguła i tak się zastosuje. Tutaj
 * dodajemy tylko to, czego rodzic nie może dotknąć (affordance klikalności) oraz
 * styl potomnego .pdp__review-count (rodzic nie sięga poza root dziecka).
 */
.pdp__rating {
  cursor: pointer;
}
.pdp__rating:focus-visible {
  outline: 2px solid var(--color-black);
  outline-offset: 3px;
}
.pdp__rating-score {
  font-size: 0.9375rem;
  font-weight: var(--font-weight-normal);
  color: var(--color-black);
  line-height: 1;
}
.pdp__review-count {
  font-size: 0.8125rem;
  font-weight: var(--font-weight-light);
  color: var(--color-muted);
}
</style>
